angular.module('tgaAdmin')
  .controller('HubRegistrationUploadModalController', [
    '$scope', '$uibModalInstance', '$uibModalStack', 'hubService',
    function (
      $scope, $uibModalInstance, $uibModalStack, hubService,
    ) {
      $scope.data = {
        alerts: [],
      };

      $scope.viewmodel = {
        from_name: null,
        from_email: null,
        from_company: null,
      };

      $scope.initialize = function () {
        const csvData = [];
        // loop through available translations and create headers
        const csvHeader = ['First Name', 'Last Name', 'Email Address'];
        csvData.push(csvHeader);
        $scope.viewmodel.template = csvData;
      };

      $scope.actions = {
        upload(event) {
          const { files } = event.target;

          if (!files) {
            return;
          }

          $scope.loading = true;
          $uibModalStack.getTop().value.backdrop = 'static';
          $uibModalStack.getTop().value.keyboard = false;

          hubService.uploadRegistration(files[0]).then(() => {
            $uibModalInstance.close();
          }).catch((error) => {
            $scope.actions.createAlert(`<span class="fa fa-exclamation-triangle"></span> ${error.message}`, 'danger');
            $scope.loading = false;
          });
        },
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
        clearAlerts() {
          $scope.data.alerts = [];
        },
        close() {
          $uibModalInstance.dismiss();
        },
      };
      $scope.initialize();
    },
  ]);
